var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 87,
    viewBox: "0 0 99 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M58.6333 87H46.8569L87.2239 57.0198L98.9999 63.7141L58.6333 87Z",
    fill: "url(#paint0_linear_1591_7969)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2236 57.0198L87.2244 63.7141L76.6912 69.7911L76.6904 63.0946L87.2236 57.0198Z",
    fill: "#BBC0E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8569 80.3045L0 53.2752L40.3677 29.9896L87.2238 57.0198L46.8569 80.3045Z",
    fill: "#F6F6FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3897 74.2279V80.9241L46.8569 87V80.3045L57.3897 74.2279Z",
    fill: "#BBC0E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8569 80.3045V86.9999L0.000380644 59.9714L0 53.2752L46.8569 80.3045Z",
    fill: "#CED3F8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M67.7349 86.8912H73.537L92.5529 75.9219L87.0358 72.4097L67.7349 86.8912Z",
    fill: "url(#paint1_linear_1591_7969)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6906 63.0946L84.1337 67.3883L64.8335 78.5243L57.3896 74.2279L76.6906 63.0946Z",
    fill: "#F6F6FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1341 67.3891L84.1353 70.7351L64.8347 81.8707L64.834 78.522L84.1341 67.3891Z",
    fill: "#BBC0E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0358 72.4096L87.0366 75.7575L67.7356 86.8912L67.7349 83.5437L87.0358 72.4096Z",
    fill: "#BBC0E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.135 70.7374L87.0363 72.4097L67.7354 83.5437L64.8345 81.8707L84.135 70.7374Z",
    fill: "#F6F6FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8343 81.8707L64.8335 78.522L57.3896 74.2279V80.9241L67.7352 86.8912V83.5437L64.8343 81.8707Z",
    fill: "#CED3F8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M84.1333 67.3884L76.6902 63.0946L87.2234 57.0199L81.3581 53.6347L46.4199 76.9206H52.7233L57.3893 74.2279L62.0541 76.9206H67.6115L84.1333 67.3884Z",
    fill: "url(#paint2_linear_1591_7969)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4194 56.0155V76.9206L5.86523 53.5283V32.6205L46.4194 56.0155Z",
    fill: "#CED3F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4199 76.9206V56.0155L63.8888 25.784L81.3581 35.8617V56.7658L46.4199 76.9206Z",
    fill: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6779 56.2163L38.9425 54.8137L30.2642 50.7858V61.6461L39.6779 67.075V56.2163Z",
    fill: "#F6F6FB"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3439 55.1578L28.9302 49.7292V60.5894L38.3439 66.0195V55.1578Z",
    fill: "#E1E6FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3438 55.1578L38.9425 54.8136V65.6735L38.3438 66.0196V55.1578Z",
    fill: "#BBC0E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9302 49.7293L29.5301 49.3843L38.9426 54.8137L38.3439 55.1579L28.9302 49.7293Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2971 55.7614L29.9766 51.5399V59.9852L37.2971 64.2089V55.7614Z",
    fill: "#5652CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2971 64.2088V63.4269L30.6537 59.596L29.9766 59.9851L37.2971 64.2088Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9766 59.9852L30.6537 59.5961V51.9309L29.9766 51.5399V59.9852Z",
    fill: "#BBC0E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3773 54.0777L33.6377 53.6506V61.3151L34.3773 61.7437V54.0777Z",
    fill: "#BBC0E6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1274 46.6696L22.3928 45.2658L13.7148 41.2375V52.0986L23.1274 57.5294V46.6696Z",
    fill: "#F6F6FB"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7944 45.612L12.3804 40.1826V51.0425L21.7944 56.4711V45.612Z",
    fill: "#E1E6FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7944 45.612L22.3928 45.2659V56.1269L21.7944 56.4711V45.612Z",
    fill: "#BBC0E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3804 40.1826L12.9795 39.8373L22.3928 45.2659L21.7944 45.6119L12.3804 40.1826Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7481 46.2144L13.4268 41.9929V50.4385L20.7481 54.6626V46.2144Z",
    fill: "#5652CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7481 54.6626V53.8806L14.1039 50.0475L13.4268 50.4384L20.7481 54.6626Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4268 50.4385L14.1039 50.0476V42.3827L13.4268 41.9929V50.4385Z",
    fill: "#BBC0E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.827 44.5307L17.0874 44.104V51.7689L17.827 52.1971V44.5307Z",
    fill: "#BBC0E6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3353 7.19068e-05L2.64697 35.8022L45.2726 60.3908L65.9609 24.5886L23.3353 7.19068e-05Z",
    fill: "#807DFB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9619 24.5878L45.2739 60.3894L46.3093 60.9873L65.9619 26.9796L85.6149 38.3137L86.6503 36.5225L65.9619 24.5878Z",
    fill: "#5652CC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.1923 10.3002L33.627 13.538V30.3726L56.1645 18.9363L41.1923 10.3002Z",
    fill: "url(#paint3_linear_1591_7969)"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6265 11.2357L41.1921 6.87238V17.2802L33.6268 30.3725L33.6265 11.2357Z",
    fill: "#BBC0E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6269 30.3726L30.3545 28.4851V9.34924L33.6265 11.2358L33.6269 30.3726Z",
    fill: "#CED3F8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6265 11.2358L30.3545 9.34929V5.48376L33.6265 7.37069V11.2358Z",
    fill: "#FB944B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1921 6.87248L33.6265 11.2358V7.3707L41.1921 3.00623V6.87248Z",
    fill: "#E57139"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1922 3.00621L33.6265 7.37068L30.3545 5.48375L37.9201 1.11945L41.1922 3.00621Z",
    fill: "#FFAF6D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M64.8345 81.8708H70.6367L87.0363 72.4097L84.135 70.7375L64.8345 81.8708Z",
    fill: "url(#paint4_linear_1591_7969)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0545 76.9205L63.2786 84.3195L57.3896 80.9241V74.2279L62.0545 76.9205Z",
    fill: "#EFEFF3"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6107 48.8294L58.8936 48.4156V69.7234L59.6107 70.1368V48.8294Z",
    fill: "#A1A9D6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8835 42.3283L70.1671 41.9141L58.8936 48.4156L59.6107 48.8294L70.8835 42.3283Z",
    fill: "#EFEFF4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6108 48.8294V70.1368L60.8631 69.4146V49.5528L69.6316 44.4957V64.4656L70.8836 63.743V42.3283L59.6108 48.8294Z",
    fill: "#C5CBEA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6317 64.4656L68.8198 63.9986V44.9643L69.6317 44.4957V64.4656Z",
    fill: "#A1A9D6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8199 63.9985V44.9642L60.8633 49.5527V68.5878L68.8199 63.9985Z",
    fill: "#CED3F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1591_7969",
    x1: 46.8569,
    y1: 72.0099,
    x2: 98.9999,
    y2: 72.0099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508031,
    stopColor: "#D8DDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8ECF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1591_7969",
    x1: 67.7349,
    y1: 79.6505,
    x2: 92.5529,
    y2: 79.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32421,
    stopColor: "#CDD2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866832,
    stopColor: "#E7E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1591_7969",
    x1: 46.4199,
    y1: 65.2776,
    x2: 87.2234,
    y2: 65.2776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555554,
    stopColor: "#E3E6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1591_7969",
    x1: 33.627,
    y1: 20.3364,
    x2: 56.1645,
    y2: 20.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246594,
    stopColor: "#C8CEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522857,
    stopColor: "#D6DAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812373,
    stopColor: "#ECEEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1591_7969",
    x1: 64.8345,
    y1: 76.3041,
    x2: 87.0363,
    y2: 76.3041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363042,
    stopColor: "#E3E8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970799,
    stopColor: "#FDFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.cb8a56666108632974f2fc7e8abe8aea.svg";
export { ForwardRef as ReactComponent };